// Payment Types Start
export const PAYMENT_TYPE_REGISTER_REQUEST = 'PAYMENT_TYPE_REGISTER_REQUEST';
export const PAYMENT_TYPE_REGISTER_SUCCESS = 'PAYMENT_TYPE_REGISTER_SUCCESS';
export const PAYMENT_TYPE_REGISTER_FAIL = 'PAYMENT_TYPE_REGISTER_FAIL';
export const PAYMENT_TYPE_REGISTER_RESET = 'PAYMENT_TYPE_REGISTER_RESET';

export const PAYMENT_TYPE_LIST_REQUEST = 'PAYMENT_TYPE_LIST_REQUEST';
export const PAYMENT_TYPE_LIST_SUCCESS = 'PAYMENT_TYPE_LIST_SUCCESS';
export const PAYMENT_TYPE_LIST_FAIL = 'PAYMENT_TYPE_LIST_FAIL';
export const PAYMENT_TYPE_LIST_RESET = 'PAYMENT_TYPE_LIST_RESET';

export const PAYMENT_TYPE_DELETE_REQUEST = 'PAYMENT_TYPE_DELETE_REQUEST';
export const PAYMENT_TYPE_DELETE_SUCCESS = 'PAYMENT_TYPE_DELETE_SUCCESS';
export const PAYMENT_TYPE_DELETE_FAIL = 'PAYMENT_TYPE_DELETE_FAIL';
// Payment Types End
